import React from "react";
import {
  getCurrentFrameIndex,
  getFrames,
  getHotspotPathState,
} from "../../redux/selectors";
import { useSelector } from "react-redux";
import { hotspotPathStates } from "../../redux/ui/ui";
import { Bead } from "./Bead";

export function HotspotPath() {
  const frames = useSelector(getFrames);
  const current = useSelector(getCurrentFrameIndex);
  const trajectoryState = useSelector(getHotspotPathState);

  return trajectoryState !== hotspotPathStates.hidden ? (
    <div
      style={{
        mixBlendMode: "difference",
      }}
      className={
        trajectoryState === hotspotPathStates.fading ? "fadeOut" : undefined
      }
    >
      {frames.map((_, i) => {
        return (
          i !== current && (
            <Bead
              key={i}
              frame={i}
              usePerFrameVisibility={trajectoryState !== hotspotPathStates.demo}
            />
          )
        );
      })}
    </div>
  ) : null;
}
